import React from 'react';
import { View, Text, ImageBackground } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import PerkBg from '../assets/perkbg.png'
import { fontFamily } from '../constants/fonts';
import { colors } from '../constants/theme';

const BenefitCard = ({ benefit, selected }) => {
  const renderIcon = (iconName) => {
    return <Ionicons name={iconName} size={24} color={selected ? 'white' : 'white'} />;
  };

  const getIconName = (benefitType) => {
    switch (benefitType) {
      case "Free Drink":
        return "beer";
      case "20% Off":
        return "star";
      default:
        return "gift";
    }
  };

  return (
    <View
      style={{
        width: 96,
        height: 96,
        borderRadius: 12,
        overflow: 'hidden',
        borderWidth: 1,
        borderColor: colors.yellow900,
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: selected ? colors.yellow900 : 'transparent',
      }}
    >
      <ImageBackground source={PerkBg} style={{ width: '100%', height: '100%', borderRadius: 999, position: 'absolute' }}/>
      {renderIcon(getIconName(benefit.benefit))}
      <Text style={{ textAlign: 'center', fontFamily: fontFamily.abhayaBold, marginTop: 8, color: colors.black }}>
        {benefit.benefit}
      </Text>
    </View>
  );
};

export default BenefitCard;